export enum CommandStatusType {
  PENDING = "PENDING",
  SENDED = "SENDED",
  PROCESSED = "PROCESSED",
  CANCELLED = "CANCELLED",
}
